import { useEffect } from 'react'
import { useMap, useMapEvent } from 'react-leaflet'

export const MapLocate = () => {
  const map = useMap()

  useEffect(() => {
    if (!map) return

    map.locate()
  }, [map])

  useMapEvent('locationfound', e => {
    map.flyTo(e.latlng, map.getZoom())
  })

  return null
}
